export const VOUCHER_LIST_REQUEST = "VOUCHER_LIST_REQUEST";
export const VOUCHER_LIST_SUCCESS = "VOUCHER_LIST_SUCCESS";
export const VOUCHER_LIST_FAIL = "VOUCHER_LIST_FAIL";
export const VOUCHER_UPDATE_STATUS="VOUCHER_UPDATE_STATUS"